export enum InboxNotificationType {
  Vinted = 'vinted',
  Braze = 'braze',
}
